import { createContext } from "react";

export const PreviewContext = createContext(false);
